import Singular from "./Singular";

interface SocialMediaLinksInputProps {
  value?: any;
  onChange: (v: any) => void;
  placeholder: string;
  invalid: boolean;
}
const socialTypes = ["Facebook", "Twitter", "Instagram", "Youtube"];

const SocialMediaLinksInput: React.FC<SocialMediaLinksInputProps> = ({
  value = [],
  onChange,
  placeholder,
  invalid,
}) => {
  return (
    <div>
      {socialTypes.map((tp: string, index: number) => (
        <Singular
          type={tp}
          key={index}
          value={value[tp] ?? ""}
          onChange={(v: any) => {
            let nv = { ...value };
            nv[tp] = v;
            onChange(nv);
          }}
        />
      ))}
    </div>
  );
};

export default SocialMediaLinksInput;
